import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useCities } from "../../hooks/useCities";
import { MSME_CITY } from "../../utils/Constants";
import * as authActions from "../../store/action/auth";
import { toastMessage } from "../../utils/Message";
import Select from "react-select";
import { storeCookie } from "../../utils/CookieAction";

const CityModal = ({ cityModal, setCityModal }) => {
  const dispatch = useDispatch();
  const { districtList } = useSelector((state) => state.menu);
  const navigate = useNavigate();
  const searchUrl = useLocation();

  const url = searchUrl?.pathname;
  const parts = url.split("/");
  const lastValue = parts.pop();

  const decodedValue = url.includes("search-product")
    ? lastValue
    : btoa("search");

  const [location, setLocation] = useState("");

  const data = districtList.map((c) => {
    return {
      label: c.name,
      value: c.name,
    };
  });

  useCities();

  const handleSearch = (e) => {
    e.preventDefault();
    if (location?.value?.length === 0) {
      toastMessage("Please Select City !", "danger", "top-center", 2000);
      return false;
    }

    if (location?.value) {
      storeCookie(MSME_CITY, location?.value);
      dispatch(authActions.storeCity(location?.value));
    }

    (searchUrl?.pathname === "/" ||
      searchUrl?.pathname.includes("about") ||
      searchUrl?.pathname.includes("buyer") ||
      searchUrl?.pathname.includes("seller") ||
      searchUrl?.pathname.includes("marketing") ||
      searchUrl?.pathname.includes("contact") ||
      searchUrl?.pathname.includes("search-product") ||
      searchUrl?.pathname.includes("verified-seller")) &&
      navigate(`/search-product/${location?.value}/${decodedValue}`);
    closeModal();
  };

  const closeModal = () => {
    setCityModal(false);
  };

  return (
    <div>
      <div
        className="modal district-modal"
        style={{ display: cityModal ? "block" : "none" }}>
        <div
          className="modal-dialog district-modal-dialog modal-sm"
          role="document">
          <div className="modal-content">
            <div
              className={`d-flex align-items-center justify-content-between`}
              style={{
                marginBottom: 10,
              }}>
              <h6 className="text-xl text-gray-800 m-0">
                🏙️ <b>Please Select a District Id</b>
              </h6>
              <button className="close-btn" onClick={closeModal}>
                ❌
              </button>
            </div>

            <form onSubmit={handleSearch}>
              <div className="col-md-12">
                <Select
                  value={location}
                  onChange={setLocation}
                  options={data}
                  placeholder={"Select District...."}
                  className="custom-select"
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      padding: 5,
                      textAlign: "left",
                    }),
                    indicatorSeparator: (provided, state) => ({
                      ...provided,
                      width: 0,
                    }),
                    menu: (provided, state) => ({
                      ...provided,
                      maxHeight: "200px", // Set maximum height of the menu
                    }),
                    menuList: (provided, state) => ({
                      ...provided,
                      maxHeight: "200px", // Set maximum height of the menu list
                    }),
                  }}
                />
              </div>

              <button
                type="submit"
                style={{
                  marginTop: 10,
                }}
                className={`continue-btn ${location ? "active" : ""}`}
                disabled={!location}>
                ✅ Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CityModal;
